import * as yup from "yup";
export const courceSchema = yup.object().shape({
  courceName: yup.string().required("Course Name Is Required"),
  topicName: yup.string(),
  topicScript: yup.string(),
  assignedTo: yup.string(),
  courceUrl1: yup.string(),
  courceUrl2: yup.string(),
  markaspublished: yup.boolean(),
  taskdedline: yup.string(),
});
